import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "./i18n";
import { AuthApp } from "./features/auth/AuthApp";
import type { AuthBootstrap } from "./features/auth/AuthApp";
import { parsePasswordResetFromPath } from "./features/auth/components/login/parsePasswordResetFromPath";

type AuthRootDataset = DOMStringMap & {
  mode?: string;
  tenantName?: string;
  redirectUrl?: string;
  passwordResetSuccessUrl?: string;
  validlink?: string;
  lang?: string;
};

const containerId = "react-auth-root";
const container = document.getElementById(containerId);

if (!container) {
  throw new Error(`Could not find React mount point with id "${containerId}".`);
}

const dataset = container.dataset as AuthRootDataset;

if (dataset.lang) {
  i18n.changeLanguage(dataset.lang);
}

const passwordResetFromPath = parsePasswordResetFromPath(
  window.location.pathname,
);

function parseInitialEmailFromQuery(): string {
  const email = new URLSearchParams(window.location.search).get("email");
  return email?.trim() ?? "";
}

const bootstrap: AuthBootstrap = {
  mode: dataset.mode ?? "login",
  tenantName: dataset.tenantName ?? "",
  redirectUrl: dataset.redirectUrl ?? "",
  passwordResetSuccessUrl: dataset.passwordResetSuccessUrl ?? "",
  initialEmail: parseInitialEmailFromQuery(),
  uidb64: passwordResetFromPath.uidb64,
  token: passwordResetFromPath.token,
  validLink: dataset.validlink === "true",
};

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <AuthApp bootstrap={bootstrap} />
  </React.StrictMode>,
);
